import SectionHeader from "../components/SectionHeader";
import Seo from "../components/Seo";
import SkillCategory from "../components/SkillCategory";
import { skillCategories } from "../content";
import { breadcrumbSchema } from "../lib/structuredData";

function SkillsPage() {
  return (
    <section id="skills">
      <Seo
        description="Technical skills across languages, frontend and mobile, backend and APIs, databases, machine learning, and security research."
        jsonLd={breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Skills", path: "/skills" }])}
        path="/skills"
        title="Skills & Tools - Robert Doe"
      />
      <SectionHeader number="02" title="Skills & Tools" />
      <div className="skills-grid">
        {skillCategories.map((category) => (
          <SkillCategory category={category} key={category.name} />
        ))}
      </div>
    </section>
  );
}

export default SkillsPage;
